import axiosIntegration from "../Common/Axios/axiosIntegration";
import API from "../Common/Endpoint/serviceConstrants";

export const callSwitchAccountPostApi = async (payload) => {
  const { data = [] } = await axiosIntegration.post(API.switchAccountApi, payload, {
    headers: {
      ClientCode: payload?.ClientCode,
      partnerCode: payload?.partnerCode,
    },
  });
  return data;
};
